import React from 'react';
import Modal from 'react-modal';
import './FeasibilityCalculator.css';

interface FeasibilityCalculatorProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const FeasibilityCalculator: React.FC<FeasibilityCalculatorProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="feasibility-modal"
      overlayClassName="feasibility-overlay"
    >
      <div className="modal-header-fc">
        <button onClick={onRequestClose} className="close-button">&times;</button>
      </div>
      
      <div style={{ width: '100%', height: '90vh', overflow: 'hidden' }}>
        <iframe
          title="Shiny App"
          src="https://performance-plus-marsci.shinyapps.io/feasibility-calculator-1/"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    </Modal>
  );
};

export default FeasibilityCalculator;